<button id="log-out" class="btn btn-primary dropdown-toggle1 noborder" data-analytics="log-out" (click)="logoutFn()">
  <span class="logout-link">
    <span class="fa fa-lock">&nbsp;</span>
    <span class="text-capitalize">log out</span>
  </span>
</button>
